export default {
  "root": "_root_125cr_1",
  "--blank": "_--blank_125cr_1",
  "--vertical": "_--vertical_125cr_1",
  "label": "_label_125cr_1",
  "--content-position-center": "_--content-position-center_125cr_1",
  "--content-position-start": "_--content-position-start_125cr_1",
  "--vertical-true--m": "_--vertical-true--m_125cr_1",
  "--vertical-false--m": "_--vertical-false--m_125cr_1",
  "--vertical-true--l": "_--vertical-true--l_125cr_1",
  "--vertical-false--l": "_--vertical-false--l_125cr_1",
  "--vertical-true--xl": "_--vertical-true--xl_125cr_1",
  "--vertical-false--xl": "_--vertical-false--xl_125cr_1"
};import "ni:sha-256;NIp9AWYt2fKAo0bIvltd1me40pbpc033nKC6dl4PAvk";